module.exports = __webpack_public_path__ + "static/media/amazonicon.66064b40.svg";